import RoomContainer from "@containers/RoomContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import _ from "lodash";
import RoomService from "@services/RoomService";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <RoomContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  const slug = _.get(params, "slug");
  const resRoom = await RoomService.find({
    filters: {
      slug: {
        $eq: slug,
      },
      hotel: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
    locale,
    populate: "deep",
  });
  if (_.isEmpty(_.get(resRoom, "data.0"))) {
    const resRoomNoLocale = await RoomService.find({
      filters: {
        slug: {
          $eq: slug,
        },
        hotel: {
          slug: {
            $eq: "amanaki-boutique-saigon",
          },
        },
      },
      locale: "all",
      populate: "deep",
    });
    if (_.isEmpty(_.get(resRoomNoLocale, "data.0"))) {
      return {
        redirect: {
          destination: "/",
          permanent: false,
        },
      };
    } else {
      const slug = _.get(
        resRoomNoLocale,
        "data.0.attributes.localizations.data.0.attributes.slug"
      );
      return {
        redirect: {
          destination: slug
            ? `/${locale}/amanaki-boutique-saigon/rooms/${slug}`
            : "/",
          permanent: true,
        },
      };
    }
  }
  const resRooms = await RoomService.find({
    filters: {
      slug: {
        $ne: slug,
      },
      hotel: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
    locale,
    populate: "deep",
    page: 1,
    pageSize: 100,
  });
  StrapiService.set("id", "hotel65-stay-connected");
  const resPage = await StrapiService.find({
    populate: "deep",
    locale,
  });
  StrapiService.set("id", "hotel65-faq");
  const resFAQ = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);

  return {
    hotel: "amanaki-boutique-saigon",
    pageData: {
      attributes: {
        ..._.get(resRoom, "data.0.attributes", {}),
        // FAQs: _.get(ROOMS, `${locale}.0.FAQs`),
      },
      stayConnected: _.get(resPage, "data", {}),
      FAQs: _.get(resFAQ, "data", {}),
    },
    rooms: _.get(resRooms, "data", []),
    footerData,
  };
});
